import { Controller } from '@hotwired/stimulus';
import { SEARCH_TOGGLE } from '../js/events';

export default class SearchButtonController extends Controller {
    onClick = (event) => {
        window.dispatchEvent(new Event(SEARCH_TOGGLE, { bubbles: true }));
    };
}
